import React, { useContext } from 'react';
import { di } from 'react-magnetic-di';
import { ForgeActionModule } from '@helpcenter/forge-action';
import {
	USER_MENU_ACTION_COMPONENT,
	USER_MENU_ACTION_SECTION_MODULE,
} from '@helpcenter/forge-ui-utils/src/constants';
import { ForgeModalContext } from '@helpcenter/forge-ui-utils/src/modal-context';

import ButtonItem from '@atlaskit/menu/button-item';
import Section from '@atlaskit/menu/section';

const ForgeMenuSectionItems = () => {
	const {
		data: { extensionTitles },
		methods: { setExtensionToDisplay },
	} = useContext(ForgeModalContext);

	if (extensionTitles.length === 0) {
		return null;
	}

	return (
		<Section hasSeparator>
			{extensionTitles.map(({ id, title }) => (
				<ButtonItem id={id} key={`hub-forge-title_${id}`} onClick={() => setExtensionToDisplay(id)}>
					{title}
				</ButtonItem>
			))}
		</Section>
	);
};

export const HubForgeMenuSection = () => {
	di(ForgeActionModule);

	return (
		<>
			<ForgeMenuSectionItems />
			<ForgeActionModule
				type={USER_MENU_ACTION_SECTION_MODULE}
				componentName={USER_MENU_ACTION_COMPONENT}
			/>
		</>
	);
};
